import { render, staticRenderFns } from "./TextDescription.vue?vue&type=template&id=7ad2162a&"
import script from "./TextDescription.vue?vue&type=script&lang=js&"
export * from "./TextDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports